export const validateFilters = (filters) => {
    return Object.keys(filters).length < 1
        ? { searchButton: { error: true, message: 'Select filters above to search' } }
        : {};
};
